module.exports = __webpack_public_path__ + "static/media/Exit-Grey.a3da875a.svg";